// extracted by mini-css-extract-plugin
export var loadingSpinner = "_4l-1";
export var standaloneTable = "_4l-0";